import {TOGGLE_MENU, HIDE_MENU} from 'store/global'
// ------------------------------------
// Actions
// ------------------------------------
export function toggleMenu (isOpen) {
  return {
    type: TOGGLE_MENU,
    isOpen,
  }
}

export function hideMenu (isCollapsed) {
  return {
    type    : HIDE_MENU,
    payload: isCollapsed,
  }
}
